import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableExporterDirective } from 'mat-table-exporter';
import * as XLSX from 'xlsx-js-style';

@Component({
  selector: 'app-extended-mat-table',
  templateUrl: './extended-mat-table.component.html',
  styleUrls: ['./extended-mat-table.component.scss'],
})
export class ExtendedMatTableComponent implements OnInit {
  @Input() columns: any[] = []; // Recebe as colunas dinamicamente como input
  @Input() dataSource: any[] = []; // Fonte de dados recebida como input
  @Input() parent!: any;
  @Input() validaCorLinha!: any;
  @Input() showPaginator: boolean = true;



  public displayedColumns: string[] = []; // Colunas a serem exibidas
  public dataSourceMatTable!: MatTableDataSource<any>; // DataSource para a mat-table
  public ordenado: string = '';
  ordernados: any[] = [];
  ordernacaoDirecao: string = 'desc';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTableExporterDirective, { static: true }) exporter!: MatTableExporterDirective;

  [key: string]: any;

  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);

    this.dataSourceMatTable = new MatTableDataSource(this.dataSource);
    this.dataSourceMatTable.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSourceMatTable.paginator = this.paginator;
    this.orderTabela();
  }

  public atualizaDados() {
    //console.log("MAT: atualizaDados");
    //console.log(this.dataSource);
    this.displayedColumns = this.columns.map(c => c.columnDef);

    this.dataSourceMatTable = new MatTableDataSource(this.dataSource);
    this.dataSourceMatTable.paginator = this.paginator;

    this.retornarOrdem();
    //this.sort.sort(({ id: '', start: 'desc' }) as MatSortable);
    //this.dataSourceMatTable.sort = this.sort;
    this.sort.sort(({ id: this.ordenado, start: this.ordernacaoDirecao }) as MatSortable);
    this.sort.disableClear = true;
    this.dataSourceMatTable.sort = this.sort;

  }

  retornarOrdem() {
    this.ordernados = this.columns.filter(column => column.ordenacaoPadrao === true).map(column => column.columnDef)
    var ordernacaoDirecao = this.columns.filter(column => column.ordenacaoPadrao === true).map(column => column.ordenacaoDirecao);
    //console.log(ordernacaoDirecao);
    this.ordernacaoDirecao = ordernacaoDirecao != undefined && ordernacaoDirecao[0] != undefined ? ordernacaoDirecao[0] : 'desc';

    if (this.ordernados.length > 0) {
      this.ordenado = this.ordernados[0];
      return this.ordenado;
    }
    return this.ordenado;
  }

  exportData(format: string, fileName: string, autor: string) {
    switch (format) {
      case 'xlsx':
        this.exportToExcelWithStyle(fileName, autor);
        break;
      case 'csv':
        if (!this.exporter) return;
        this.exporter.exportTable('csv', { fileName: fileName, Props: { Author: autor } });
        break;
      default:
        console.warn('Formato não suportado para exportação');
    }
  }

  private exportToExcelWithStyle(fileName: string, autor: string) {
    const exportColumns = this.columns.filter(col => this.isColumnIncludedInExport(col));

    const headers = exportColumns.map(col => col.header);

    const data = this.dataSourceMatTable.filteredData.map(row => {
      return exportColumns.map(col => this.formatCellValue(row, col));
    });

    // Criar worksheet
    const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Aplicar estilos ao cabeçalho
    const headerStyle = {
      font: { bold: true, color: { rgb: "151515" }, sz: 11 },
      fill: { fgColor: { rgb: "FFFFFF" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin", color: { rgb: "D3D3D3" } },
        bottom: { style: "thin", color: { rgb: "D3D3D3" } },
        left: { style: "thin", color: { rgb: "D3D3D3" } },
        right: { style: "thin", color: { rgb: "D3D3D3" } }
      }
    };

    // Estilo para linhas pares (branco)
    const evenRowStyle = {
      alignment: { vertical: "top", wrapText: true },
      fill: { fgColor: { rgb: "FFFFFF" } },
      border: {
        top: { style: "thin", color: { rgb: "D3D3D3" } },
        bottom: { style: "thin", color: { rgb: "D3D3D3" } },
        left: { style: "thin", color: { rgb: "D3D3D3" } },
        right: { style: "thin", color: { rgb: "D3D3D3" } }
      }
    };

    // Estilo para linhas ímpares (cinza claro)
    const oddRowStyle = {
      alignment: { vertical: "top", wrapText: true },
      fill: { fgColor: { rgb: "E6E6E6" } },
      border: {
        top: { style: "thin", color: { rgb: "D3D3D3" } },
        bottom: { style: "thin", color: { rgb: "D3D3D3" } },
        left: { style: "thin", color: { rgb: "D3D3D3" } },
        right: { style: "thin", color: { rgb: "D3D3D3" } }
      }
    };

    // Estilo para linhas em destaque na exportação (via parent.excelExportRowHighlight)
    const highlightRowStyle = {
      alignment: { vertical: "top", wrapText: true },
      fill: { fgColor: { rgb: "FFCCCC" } },
      border: {
        top: { style: "thin", color: { rgb: "D3D3D3" } },
        bottom: { style: "thin", color: { rgb: "D3D3D3" } },
        left: { style: "thin", color: { rgb: "D3D3D3" } },
        right: { style: "thin", color: { rgb: "D3D3D3" } }
      }
    };

    // Aplicar estilo aos cabeçalhos
    for (let i = 0; i < headers.length; i++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
      if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
      ws[cellRef].s = headerStyle;
    }

    // Aplicar estilo às células de dados
    for (let r = 0; r < data.length; r++) {
      const row = this.dataSourceMatTable.filteredData[r];
      const isHighlight = this.shouldApplyExcelHighlightRowStyle(row);
      const isEvenRow = r % 2 === 0;

      let styleToApply;
      if (isHighlight) {
        styleToApply = highlightRowStyle;
      } else if (isEvenRow) {
        styleToApply = evenRowStyle;
      } else {
        styleToApply = oddRowStyle;
      }
      
      for (let c = 0; c < headers.length; c++) {
        const cellRef = XLSX.utils.encode_cell({ r: r + 1, c: c });
        if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
        ws[cellRef].s = styleToApply;
      }
    }

    // Ajustar largura das colunas
    const colWidths = exportColumns.map(col => ({
      wch: this.excelColumnWidthChars(col),
    }));
    
    ws['!cols'] = colWidths;

    // Criar workbook
    const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: fileName,
      Author: autor,
      CreatedDate: new Date()
    };
    XLSX.utils.book_append_sheet(wb, ws, 'Dados');

    // Salvar arquivo
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  private formatCellValue(row: any, col: any): string {
    if (col.multiValor && col.campos) {
      // Processar células com múltiplos valores
      const values = col.campos
        .map((campo: any) => {
          const value = row[campo.campo];
          if (value === null || value === undefined || value === '') return '';
          
          const prefix = campo.columnDef || '';
          const formattedValue = this.format(value, campo.format);
          return prefix + formattedValue;
        })
        .filter((v: string) => v !== '');
      
      return values.join('\n');
    } else {
      // Processar células com valor único
      const value = row[col.columnDef];
      if (value === null || value === undefined || value === '') return '';
      return this.format(value, col.format);
    }
  }

  orderTabela() {
    this.retornarOrdem();
    //this.sort.sort(({ id: '', start: 'desc' }) as MatSortable);
    //this.dataSourceMatTable.sort = this.sort;
    this.sort.sort(({ id: this.ordenado, start: this.ordernacaoDirecao }) as MatSortable);
    this.sort.disableClear = true;
    this.dataSourceMatTable.sort = this.sort;
  }

  format(value: any, formatType: string | null): string {
    if (!formatType) {
      return value;
    }

    switch (formatType) {
      case 'date':
        return new Intl.DateTimeFormat('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).format(new Date(value));
      case 'datetime': {
        const date = new Date(value);
        const formattedDate = date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedTime = date.toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
        return `${formattedDate} ${formattedTime}`;
      }
      case 'time':
        return new Date(value).toLocaleTimeString('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
      case 'currency':
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
      case 'numeric2':
        return new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      case 'numeric3':
        return new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3
        }).format(value);
      case 'cpf': {
          let cpf = value.toString().replace(/\D/g, ''); // Remove caracteres não numéricos
          if (cpf.length === 11) {
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
          }
          return value; // Se não tiver 11 dígitos, retorna o valor como está
        }
      default:
        return value;
    }
  }

  handleAction(action: any, row: any): void {
    switch (action.tipo) {
      case 'URL':
        // Constrói a URL com parâmetros
        const urlWithParams = this.buildUrlWithParams(action.link, action.parametros, row);
        window.location.href = urlWithParams;
        break;
      case 'FUNCTION':
        // Obtém os parâmetros para a função JS
        const params = this.getJSFunctionParams(action.parametros, row);
        this.callTypeScriptMethod(action.link, ...params);
        break;
      case 'FUNCTION_ROW':
        this.callTypeScriptMethod(action.link, row);
        break;
      default:
        console.warn(`Ação não reconhecida: ${action.tipo}`);
        return;
    }
  }

  // Função para construir a URL com parâmetros
  private buildUrlWithParams(link: string, params: any[], row: any): string {
    const url = new URL(link, window.location.origin);

    params.forEach(param => {
      const value = row[param.valor]; // Obtém o valor do row baseado no campo 'valor'
      if (value !== undefined) {
        url.searchParams.append(param.nome, value);
      }
    });

    return url.toString();
  }

  private getJSFunctionParams(params: any[], row: any): any[] {    
    return params.map(param => row[param.valor]);;
  }

  private callTypeScriptMethod(methodName: string, ...args: any[]): void {
    if (this.parent && typeof this.parent[methodName] === 'function') {
      this.parent[methodName](...args);
    } else {
      console.log(`${methodName} não é uma função ou não existe.`);
    }
  }

  filteredColumns(colunas: any[]) {
    return colunas.filter(c => Array.isArray(c.actions) && c.actions.length > 0);
  }

  /**
   * Colunas com `actions` (menus/botões) não entram na planilha.
   * Use `excludeFromExport` / `includeInExport` para casos especiais.
   */
  private isColumnIncludedInExport(col: any): boolean {
    if (col?.includeInExport === true) {
      return true;
    }
    if (col?.excludeFromExport === true) {
      return false;
    }
    if (Array.isArray(col?.actions) && col.actions.length > 0) {
      return false;
    }
    return true;
  }

  /** Largura em caracteres (`wch`); opcional `excelWidthChars` na definição da coluna. */
  private excelColumnWidthChars(col: any): number {
    const w = col?.excelWidthChars;
    if (typeof w === 'number' && w > 0) {
      return w;
    }
    if (col?.multiValor) {
      return 25;
    }
    const fmt = col?.format;
    switch (fmt) {
      case 'date':
        return 12;
      case 'datetime':
        return 20;
      case 'time':
        return 10;
      case 'currency':
        return 15;
      case 'numeric2':
      case 'numeric3':
        return 14;
      case 'cpf':
        return 16;
      default:
        return 20;
    }
  }

  /**
   * Se `parent.excelExportRowHighlight(row)` existir e retornar true, aplica o estilo
   * de destaque na linha exportada (ex.: transação rejeitada).
   */
  private shouldApplyExcelHighlightRowStyle(row: any): boolean {
    const p = this.parent;
    if (p && typeof p['excelExportRowHighlight'] === 'function') {
      try {
        return !!p['excelExportRowHighlight'](row);
      } catch {
        return false;
      }
    }
    return false;
  }

  getRowStyle(linha: any): string {
    if (this.parent && typeof this.parent['getRowStyle'] === 'function') {
      return this.parent['getRowStyle'](linha);
    }
    return '';
  }

  getRowClass(row: any, condition: string) {
    if (condition != undefined && condition != '') {
      try {
        const evaluator = new Function('row', condition);
        return evaluator(row);;
      } catch (e) {
        console.error('Erro ao avaliar a condição linha:', e);
        return '';
      }
    }
  }

}